import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';

import {Clearance, CommonDataService, EnumType, Format, PrimeNgConfig, PrimeNgSupportService, RefDomainType, TableColumn, TableFormat, Validation} from '@app/shared';
import {classToClass} from "class-transformer";

@Component({
  selector: 'app-clearance',
  templateUrl: './clearance.component.html',
  styleUrls: ['./clearance.component.css'],
  providers: [ConfirmationService]
})
export class ClearanceComponent implements OnInit,AfterViewInit {

  @Input() clearances: Clearance[];
  @Output() clearanceChangeHandler = new EventEmitter<Clearance[]>();

  // standard format and validation
  Format: typeof Format = Format;
  Validation: typeof Validation = Validation;
  PrimeNgConfig: typeof PrimeNgConfig = PrimeNgConfig;


  clearanceToEdit: Clearance;
  clearanceTableColumns: TableColumn[];
  clrDisplayDialog: boolean;
  clrStatusTypeDropDown: SelectItem[] = [];
  clearanceTypeDropDown: SelectItem[] = [];
  remainingClearanceTypeDropDown: SelectItem[] = [];

  maxDobEndOn: Date;

  selectedRowIndex: number;

  @ViewChild('clearanceAction') clearenceAction: TemplateRef<any>;
  sortField =  "type";

  constructor (private confirmationService: ConfirmationService, private commonDataService: CommonDataService, private primeNgService: PrimeNgSupportService) { }

  ngOnInit() {
    this.getClearanceTypes();
    this.maxDobEndOn = new Date();
  }

  ngAfterViewInit() {
    void Promise.resolve(null).then(() => this.initializingClearanceTableColumns());
  }

  initializingClearanceTableColumns(): void {
    this.clearanceTableColumns = [
      { field: 'type', header: 'Clearance Type', format: TableFormat.TitleCase },
      { field: 'statusType', header: 'Clearance Status', format: TableFormat.TitleCase },
      { field: 'grantingInstitution', header: 'Granting Institution' },
      { field: 'clearanceGrantedOn', header: 'Granted On', format: TableFormat.Date },
      { field: 'action', header: 'Actions', template: this.clearenceAction },
    ];
  }

  getClearanceTypes(): void {
    this.commonDataService.getRefCodeAsDropdown(RefDomainType.Clearance, true, null, true).subscribe(clearanceTypes => {
      this.clearanceTypeDropDown = clearanceTypes;
    });
    this.commonDataService.getEnumPairAsDropdown(EnumType.ClearanceStatus).subscribe(clrStatusTypes => {
      this.clrStatusTypeDropDown = clrStatusTypes;
    });
  }

  /**
   * @desc gets the list of phone types for add/edit which are not already available in the table containing phone information of the employee
   */
  getRemainingClearanceTypes(): void {
    this.remainingClearanceTypeDropDown = classToClass(this.clearanceTypeDropDown);

    for (const type of this.clearanceTypeDropDown) {
      if (this.clearanceToEdit && this.clearanceToEdit.type && type.value == this.clearanceToEdit.type) {
        continue;
      } else {
        if (this.clearances.find(clr => clr.type == type.value)) {
          this.remainingClearanceTypeDropDown.splice(this.remainingClearanceTypeDropDown.indexOf(type), 1);
        }
      }
    }
    this.remainingClearanceTypeDropDown = [...this.remainingClearanceTypeDropDown];
  }

  /**
   * @desc show a pop-up dialog to gather new emergency contact information
   * @returns this.copiedRow - instantiated
   *          this.displayDialog - set to true, so popup dialog is shown to gather a new emergency contact info
   */
  onClickAddClearance(): void {
    this.clearanceToEdit = new Clearance();
    this.getRemainingClearanceTypes();
    this.selectedRowIndex = -1;
    this.clrDisplayDialog = true;
  }

  onCancelEditClearance(): void {
    this.clrDisplayDialog=false
  }

  /**
   * @desc edit an existing emergency contact
   * @param clearance - selected emergency contact to edit
   * @param rowIndex
   * @returns this.copiedRow - has copy of the selected emergency contact
   *          displayDialog - set it to true which in turn open up an edit dialog
   */
  onClickEditClearance(clearance: Clearance): void {
    this.clearanceToEdit = new Clearance();
    this.clearanceToEdit = classToClass(clearance);
    this.getRemainingClearanceTypes();
    const index = this.clearances.indexOf(clearance);
    this.selectedRowIndex = index;
    this.clrDisplayDialog = true;
  }

  /**
   * @desc save new emergency contact to the inputArray
   * @param clearance - either new or selected emergency contact for edit
   * @returns: this.inputArray - new emergency contact added to the array
   */
  onClickSaveClearance(clearance: Clearance): void {
    this.commonDataService.getRefCodeAsDropdown("CLEARANCE").subscribe(clearanceTypes => {
      this.clearanceToEdit.clearanceId = clearanceTypes.find(clearanceType => (clearanceType.label == clearance.type)).value;

      if (this.selectedRowIndex >= 0) {
        this.clearances = this.primeNgService.replaceByIndex(this.clearances, this.clearanceToEdit, this.selectedRowIndex);
        this.selectedRowIndex = -1;
      } else {
        this.clearances = this.primeNgService.unshift(this.clearances, this.clearanceToEdit);
      }
      this.triggerValueChangedEvent();
      this.clrDisplayDialog = false;
    });

  }

  /**
   * @desc delete the selected row from the inputArray
   * @returns: this.inputArray - removed input row from the array
   * @param rowIndex
   */
  onClickDeleteClearance(clearance: Clearance): void {
    const rowIndex = this.clearances.indexOf(clearance);
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this Clearance?',
      header: 'Delete Clearance',
      icon: 'fa fa-question-circle',
      accept: () => {
        if (rowIndex >= 0) {
          this.clearances = this.primeNgService.deleteByIndex(this.clearances, rowIndex);
          this.triggerValueChangedEvent();
        }
      },
      reject: () => {
      }
    });
  }

  triggerValueChangedEvent(): void {
    this.clearanceChangeHandler.emit(this.clearances);
  }

}
